import styled from 'styled-components';

import accountAvatarPlaceholder from '../../static/account-avatar-placeholder.svg';

const accountAvatarPlaceholderUrl = `url("${accountAvatarPlaceholder}")`;

export const Avatar = styled.img`
  flex-shrink: 0;
  display: block;
  background-color: var(--white);
  background-image: ${accountAvatarPlaceholderUrl};
  background-size: 100%;
  border: 4px solid var(--white);
  border-radius: var(--border-radius-round);
  overflow: hidden;
  color: transparent;
`;
